import React, { useState, useEffect } from 'react';
import { apiBase, getApiData, postApiData } from './api';
import '/node_modules/react-grid-layout/css/styles.css';
import '/node_modules/react-resizable/css/styles.css';
import Details from './Details';
import 'react-data-grid/lib/styles.css';
import LoadingOverlay from 'react-loading-overlay-ts';

import Select from 'react-select'
import { all } from 'axios';

const FeedsTabs = ({ idToken, refreshToken, setIsLoggedIn, isLoggedIn }) => {
  const [tabItems, setTabItems] = useState([]);

  const [currentDropDowns, setCurrentDropDowns] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);

  const [selectData, setSelectData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [selectorIsMulti, setSelectorIsMulti] = useState({
    'technical_level': false,
    'article_language': false,
    'cve_number': false
  });

  const [isSelectorsLoading, setIsSelectorsLoading] = useState(false);

  const isCurrentSelectionEmpty = (currentSelectData) => {
    if(!currentSelectData) {
      return true;
    }

    if((Object.keys(currentSelectData).length <= 0) || !Object.keys(currentSelectData).some((key) => currentSelectData[key].length > 0)) {
      return true;
    }

    return false;
  };

  const fetchDropDowns = async (currentSelectData) => {
    const today = new Date();
    const startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    const startDateLimited = startDate.toISOString().slice(0, 10);

    const feedDropdownsUrl = `${apiBase()}/m/get_feed_dropdowns/${startDateLimited}`;

    try {
      var selectorFetchResponse = null;
      console.log(currentSelectData);
      if(!isCurrentSelectionEmpty(currentSelectData)) {
        console.log("Got select data");
        selectorFetchResponse = await postApiData(feedDropdownsUrl, currentSelectData, idToken, refreshToken, setIsLoggedIn);
      } else {
        console.log("No select data");
        selectorFetchResponse = await getApiData(feedDropdownsUrl, idToken, refreshToken, setIsLoggedIn);
      }

      const responseData = selectorFetchResponse.data;
      console.log(`responseData (${JSON.stringify(responseData)})`);

      const labelItems = responseData.items;
      const dropdownLabels = Object.keys(labelItems).sort();
      console.log(dropdownLabels);

      const dropDowns = {};
      for(var dropdownLabel of dropdownLabels) {
        const dropDownItems = labelItems[dropdownLabel].map((item) => {
          return {
            dropdownKey: item.thing,
            dropdownCount: item.count,
          };
        });

        dropDowns[dropdownLabel] = dropDownItems;
      }

      for(var dropdownLabel of Object.keys(dropDowns)) {
        if(!(dropdownLabel in selectorIsMulti)) {
          console.log("thing not in selectorIsMulti");
          setSelectorIsMulti({ ...selectorIsMulti, [dropdownLabel]: true });
        }
      }

      return dropDowns;
    } catch(e) {
      console.error(e);
      setIsLoggedIn(false);
    }
  };

  const updateDropDowns = (fetchedDropDowns, currentSelectData) => {
    console.log(`fetchedDropDowns: ${JSON.stringify(fetchedDropDowns)}`);

    const dropDowns = {};
    var referenceDropDowns = allDropdowns;

    if(!referenceDropDowns || (Object.keys(referenceDropDowns).length <= 0)) {
      referenceDropDowns = fetchedDropDowns;
      setAllDropdowns(fetchedDropDowns);
    }

    // examine all the dropdowns we have previously fetched
    for(var label of Object.keys(referenceDropDowns)) {
      console.log(`label: ${label}`);


      if(!(label in fetchedDropDowns)) {
        console.log("label not in fetchedDropDowns");
        dropDowns[label] = referenceDropDowns[label].map((item) => { return { value: item.dropdownKey, label: `${label}: ${item.dropdownKey} (0/0)`, isDisabled: false } });
        dropDowns[label].unshift({ value: null, label: `${label}: All`, isDisabled: false });
        continue;
      }

      dropDowns[label] = [];
      dropDowns[label].push({ value: null, label: `${label}: All`, isDisabled: false });

      for(var item of referenceDropDowns[label]) {
        var fetchedItem = fetchedDropDowns[label].find((findFetchedItem) => findFetchedItem.dropdownKey === item.dropdownKey);
        if(!fetchedItem) {
          dropDowns[label].push({
            value: item.dropdownKey,
            label: `${label}: ${item.dropdownKey} (0)`,
            isDisabled: false
          });
          continue;
        }

        dropDowns[label].push({
          value: fetchedItem.dropdownKey,
          label: `${label}: ${fetchedItem.dropdownKey} (${fetchedItem.dropdownCount})`,
          isDisabled: false
        });
      }
    }

    setTabItems(dropDowns);
  };

  const fetchSelectors = async (currentSelectData) => {    
    setIsSelectorsLoading(true);

    try {
      const dropDowns = await fetchDropDowns(currentSelectData);

      // If we have no current select data, then set all dropdowns
      // This allows us to add dropdowns that are not present given the current selection
      if(isCurrentSelectionEmpty(currentSelectData)) {
        console.log("SETTING ALL SELECTORS");
        setAllDropdowns(dropDowns);
      }

      updateDropDowns(dropDowns, currentSelectData);

      setCurrentDropDowns(dropDowns);
      setIsSelectorsLoading(false);

      return;

      console.log("UPDATING SELECTORS");

      // examine all the dropdowns we have previously fetched
      for(var thing of Object.keys(allDropdowns)) {
        console.log(`thing: ${thing}`);


        // if the thing is multi
        // then we need to add any items missing from the retrieved dropdowns, into the dropdown list, but disabled
        if(selectorIsMulti[thing]) {
          console.log("thing is multi");
          if(!(thing in dropDowns)) {
            console.log("thing not in dropDowns");
            dropDowns[thing] = allDropdowns[thing].map((item) => { return { value: item.value, label: item.label, isDisabled: true } });
          } else {
            console.log("thing in dropDowns");
            // go through the items, looking for those that are missing in the fetched thing/dropdowns
            dropDowns[thing] = [...dropDowns[thing], ...allDropdowns[thing].map((item) => {
              console.log(item);
              const existingItem = dropDowns[thing].find((existingItem) => existingItem.value === item.value);

              if(existingItem) {
                return null;
              }

              console.log(`SETTING DISABLED: ${thing}/${item.value}`);
              return { value: item.value, label: item.label, isDisabled: true };
            })].filter((item) => item !== null);
          }
        } else {
          dropDowns[thing] = allDropdowns[thing].map((item) => { return { value: item.value, label: item.label, isDisabled: false } });
          dropDowns[thing].push({ value: null, label: `${thing}: All`, isDisabled: false });
          console.group('Drop Down Items');
          console.log(dropDowns[thing]);
          console.groupEnd();
        }
      }

      setTabItems(dropDowns);

      setIsSelectorsLoading(false);
    } catch(e) {
      console.error(e);
      setIsLoggedIn(false);
    }
  };

  useEffect(() => {
    fetchSelectors(selectData);

    return () => {
    };
  }, [ selectData ]);

  const onChange = (selectName, newValue) => {
    console.group('Value Changed');
    console.log(selectName)
    console.log(newValue);
    console.groupEnd();

    // if newValue is an array, then simply set the value
    // otherwise, wrap new value in an array
    console.group('Non Empty Select Data');
    console.log(`selectData (${JSON.stringify(selectData)})`);
    const newValueArray = Array.isArray(newValue) ? newValue : [newValue];
    const newSelectData = {...selectData, [selectName]: newValueArray};
    console.log(`newSelectData (${JSON.stringify(newSelectData)})`);
    console.groupEnd();

    console.group('Non Empty Select Data');
    const nonEmptySelectDataKeys = Object.keys(newSelectData).filter((key) => (newSelectData[key].length > 0) && (newSelectData[key][0].value !== null));
    console.log(`nonEmptySelectDataKeys (${JSON.stringify(nonEmptySelectDataKeys)})`);
    const nonEmptySelectData = {};
    for(var key of nonEmptySelectDataKeys) {
      nonEmptySelectData[key] = newSelectData[key];
    }
    console.log(`nonEmptySelectData (${JSON.stringify(nonEmptySelectData)})`);
    console.groupEnd();

    setSelectData(nonEmptySelectData);

    console.group('New Select Data');
    console.log(`nonEmptySelectData (${JSON.stringify(nonEmptySelectData)})`);
    console.log("updating selectors");
    console.log("selectors updated");
    console.groupEnd();
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'lightblue', // Background color of the control
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'lightblue', // Background color of the dropdown menu
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled
        ? 'lightgray' // Background color for disabled options
        : state.isSelected
        ? 'blue'       // Background color for selected options
        : state.isFocused
        ? 'lightblue'  // Background color on hover
        : 'white',     // Background color for normal options
      color: state.isDisabled
        ? 'gray'       // Font color for disabled options
        : state.isSelected
        ? 'white'      // Font color for selected options
        : 'black',     // Font color for normal options
      cursor: state.isDisabled ? 'not-allowed' : 'default',
  
      ':active': {
        ...provided[':active'],
        backgroundColor: !state.isDisabled && (state.isSelected ? 'blue' : 'lightblue'),
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black', // Font color of the selected value
    }),
  };

  const leftColumn = Object.keys(tabItems).sort().map((tabName) => (
    // <Select isMulti={selectorIsMulti[tabName]} styles={customStyles} options={tabItems[tabName]} name={tabName} placeholder={tabName} onChange={(option) => onChange(tabName, option)}/>
    <Select styles={customStyles} options={tabItems[tabName]} name={tabName} placeholder={tabName} onChange={(option) => onChange(tabName, option)}/>
  ));

  return (
    <div>
      <div className="grid-container">
        <div className="left-column">
          <LoadingOverlay
            active={isSelectorsLoading}
            spinner
            text='Loading your content...'
          >
            <h3>Total items: {totalRows}</h3>
            {leftColumn}
          </LoadingOverlay>
        </div>
        {/* <div className="right-column" style={{ position: 'relative', bottom: 0, width: '95%', overflow: 'auto' }}> */}
        {/* <div className="right-column" style={{ position: 'relative', bottom: 0, width: '100%', overflow: 'auto'  }}> */}
        <div className="right-column" style={{ position: 'relative', bottom: 0, width: '100%', overflow: 'auto'  }}>
            <Details 
              selectData={selectData} 
              setTotalRows={setTotalRows}
              idToken={idToken}
              setIsLoggedIn={setIsLoggedIn}
              isLoggedIn={isLoggedIn}
              refreshToken={refreshToken}
            />
        </div>
      </div>
    </div>
  );
};

export default FeedsTabs;
